<template>
  <time class="timer" v-html="duration" />
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Timer',
    props: {
      started: {
        type: String,
        required: true,
      },
      active: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data() {
      const now = Date.now()
      const started = new Date(this.started).getTime()
      return {
        current: started > now ? started : now
      }
    },
    computed: {
      duration() {
        const duration = moment.duration({seconds: moment(this.current).diff(this.started, 'seconds')})._data
        if (duration.days) {
          return `${duration.days}&nbsp;d`
        }
        if (duration.hours) {
          return `${duration.hours}&nbsp;h&nbsp;${duration.minutes}&nbsp;m`
        }
        if (duration.minutes) {
          return `${duration.minutes}&nbsp;m&nbsp;${duration.seconds}&nbsp;s`
        }
        return `${duration.seconds}&nbsp;s`
      },
    },
    methods: {
      update() {
        if (this.active) {
          this.current += 1000
        }
      },
    },
    created() {
      this.$options.timer = setInterval(this.update, 1000)
    },
    beforeDestroy() {
      clearInterval(this.$options.timer)
    },
  }
</script>
